





































































































import { Component, Prop, Watch } from "vue-property-decorator";
import { LineItem } from "@/models/order/order";
import { ProductType } from "@/models/products/product";
import QtyPicker from "@/components/elements/utility/QtyPicker.vue";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import { Mobile } from "@/mixins/mobile";
import { mixins } from "vue-class-component";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { CustomUmbrellaOrder } from "@/models/configurator/custom_umbrella";
/** SEE PRICING DIAGRAM FOR MORE INFORMATION */
@Component({
  components: {
    QtyPicker,
  },
})
export default class AddToQuoteFooter extends mixins(Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetAssignedCustomer))
  customer!: string;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: number;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: number) => Promise<void>;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrderItems))
  items!: LineItem[];
  @Prop() type!: ProductType;
  @Prop() model!: string;
  @Prop() itemPrice!: number;
  @Prop() itemDetails?: CustomUmbrellaOrder["canopy"];
  @Prop() displayName!: string;
  @Prop() productLineName!: string;
  @Prop() editMode!: boolean;
  @Prop() sku!: string;
  protected allowSubmit = true;
  protected lineItem: LineItem = {
    product_type: this.type,
    multiplier: 1, // v-model binded
    sku: "",
    model: "",
    product_line: "",
    qty: 1, // v-model binded
    unit_price: 0,
    display_name: "",
    notes: "",
  };
  protected originalItem: LineItem | null = null;

  @Watch("multiplier")
  private updateMultiplier(): void {
    this.lineItem.multiplier = this.multiplier;
  }

  @Watch("sku")
  private updateSKU(): void {
    this.lineItem.sku = this.sku;
  }

  created() {
    if (this.editMode) {
      this.updateOriginalItem();
    }
    this.lineItem.multiplier = this.multiplier
    this.lineItem.qty = this.originalItem?.qty ? this.originalItem.qty : 1;
  }

  protected updateOriginalItem(): void {
    const index = parseInt(this.$route.query.cart as string, 10);
    this.originalItem = this.items[index];
  }

  protected submitItem(): void {
    this.lineItem.model = this.model;
    this.lineItem.display_name = this.displayName;
    this.lineItem.product_line = this.productLineName;
    this.lineItem.unit_price = this.itemPrice;
    if (this.editMode) {
      if (
        this.originalItem?.product_type !== this.lineItem.product_type ||
        this.originalItem?.product_line !== this.lineItem.product_line
      ) {
        this.$router.replace("/resubmit");
      } else {
        this.$emit("editQuote", this.lineItem);
      }
    } else {
      this.$emit("addToQuote", this.lineItem);
    }
  }

  protected setQty(qty: number) {
    this.lineItem.qty = qty;
  }

  protected toggleSubmit(res: boolean) {
    this.allowSubmit = res;
  }

  get price(): number {
    const numberPrice =
      this.itemPrice * this.lineItem.multiplier * this.lineItem.qty;
    return numberPrice;
  }

  get MSRP(): number {
    const numberPrice = this.itemPrice * this.lineItem.qty;
    return numberPrice;
  }
}
